var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg4Runs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66989 16.2608L4.20989 16.7908L3.58989 17.4008C3.84081 17.7919 4.12165 18.163 4.42989 18.5108L18.5099 4.42077C18.161 4.12125 17.7936 3.84403 17.4099 3.59077L16.7899 4.20077L16.2599 3.67077L16.7399 3.19077C14.8461 2.17235 12.6744 1.7915 10.547 2.10472C8.41966 2.41794 6.44993 3.40855 4.93 4.9296C3.41007 6.45065 2.42091 8.42112 2.10926 10.5487C1.79761 12.6763 2.18006 14.8477 3.19989 16.7408L3.66989 16.2608ZM14.8599 5.07077L15.3899 5.60077L13.9999 7.00077L13.4699 6.47077L14.8599 5.07077ZM12.0699 7.87077L12.5899 8.40077L11.1999 9.80077L10.6699 9.27077L12.0699 7.87077ZM9.26989 10.6708L9.79989 11.2008L8.39989 12.5908L7.86989 12.0608L9.26989 10.6708ZM6.46989 13.4608L6.99989 14.0008L5.59989 15.4008L5.06989 14.8708L6.46989 13.4608ZM6.58989 20.4108L7.20989 19.8008L7.73989 20.3308L7.25989 20.8108C9.15372 21.8292 11.3254 22.2101 13.4527 21.8968C15.5801 21.5836 17.5498 20.593 19.0698 19.0719C20.5897 17.5509 21.5789 15.5804 21.8905 13.4528C22.2022 11.3252 21.8197 9.15385 20.7999 7.26077L20.3299 7.74077L19.7899 7.21077L20.4099 6.60077C20.159 6.20964 19.8781 5.83853 19.5699 5.49077L5.48989 19.5808C5.83873 19.8803 6.20613 20.1575 6.58989 20.4108ZM18.3999 8.61077L18.9299 9.14077L17.5299 10.5408L16.9999 10.0008L18.3999 8.61077ZM15.5999 11.4108L16.1299 11.9408L14.7299 13.3308L14.1999 12.8008L15.5999 11.4108ZM12.7999 14.2008L13.3299 14.7308L11.9399 16.1308L11.3999 15.6008L12.7999 14.2008ZM9.99989 17.0008L10.5299 17.5308L9.12989 18.9308L8.59989 18.4008L9.99989 17.0008Z",
    fill: "#F37121"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67259 13.9773V13.0085L12.1016 9.18182H12.9368V10.5227H12.4425L10.9112 12.946V12.9915H14.3629V13.9773H9.67259ZM12.4652 15V13.6818L12.4879 13.2528V9.18182H13.6413V15H12.4652Z",
    fill: "#F37121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Runs);
export default __webpack_public_path__ + "static/media/4runs.85850b6aeaefa98ea00026f017be3420.svg";
export { ForwardRef as ReactComponent };